import { render, staticRenderFns } from "./NovidadesGridView.vue?vue&type=template&id=5a0bd0fe&scoped=true&"
import script from "./NovidadesGridView.vue?vue&type=script&lang=js&"
export * from "./NovidadesGridView.vue?vue&type=script&lang=js&"
import style0 from "./NovidadesGridView.vue?vue&type=style&index=0&id=5a0bd0fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0bd0fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
